import { ShippingMethod } from '@crocodille/api/lib/model/shipping';
import { useCallback } from 'react';
import { useLocalStorage } from './use-local-storage';
import { Order } from '@crocodille/common/dist/lib/modules/order.v2';
import { getDeliveryFromOrder } from '@crocodille/common/lib/modules/order.v2';

export function useLastOrderDelivery() {
  const [lastOrderDelivery, setLastOrderDelivery] = useLocalStorage<any>(
    'lastOrderDeliveryInfo',
    null,
  );

  const [orderCourierInfo, setOrderCourierInfo] = useLocalStorage<any>(
    'orderCourierInfo',
    null,
  );

  const saveDelivery = useCallback(
    (order: Order, inRestaurantShippingMethods?: ShippingMethod[]) => {
      const deliveryData = {
        branchCode: order.branchCode,
        deliveryMethodType: order.deliveryMethodType,
        shippingMethodType: order.shippingMethodType,
        specialDelivery: order.specialDelivery,
        shippingAddress: order.shippingAddress,
        delivery: getDeliveryFromOrder(
          order,
          inRestaurantShippingMethods,
          orderCourierInfo && orderCourierInfo.addressDataId,
        ),
      };

      setLastOrderDelivery(deliveryData);
    },
    [setLastOrderDelivery, orderCourierInfo],
  );

  return {
    saveDelivery,
    lastOrderDelivery,
    isLastOrderDelivery: Boolean(lastOrderDelivery),
    setOrderCourierInfo,
  };
}
